module.exports = __webpack_public_path__ + "img/3.70826dc0.png";